import Populator from './populator.js';

export default class QueryStringPopulator extends Populator {

    constructor(input){
        super(input);
        this.queryParams = new URLSearchParams(location.search);
    }

    fromQuery(key) {
        return this.queryParams.get(key);
    }

    populate() {
        const key = this.input.el.dataset.query;
        const value = this.fromQuery(key);
        if (value) {
            super.populate(value);            
        }
    }

    static applies(input) {
        return input.el.dataset.query !== undefined;
    }
}
